import { Modal } from "@circleco/compass/components/Modal";
import { Typography } from "@circleco/compass/components/Typography";

import { t } from "@/i18n-js/instance";

import type { VideoClipConfirmCloseDialogProps } from "./types";

interface VideoClipConfirmCloseDialogComponentProps extends VideoClipConfirmCloseDialogProps {
  onOpenChange: (open: boolean) => void;
  open: boolean;
}

const i18nRoot = "tiptap.video_clip.confirm_close";

export const VideoClipConfirmCloseDialogComponent = ({
  onConfirm,
  open,
  onOpenChange,
}: VideoClipConfirmCloseDialogComponentProps) => {
  const handleConfirm = () => {
    onConfirm();
    onOpenChange(false);
  };

  return (
    <Modal.Root open={open} onOpenChange={onOpenChange} size="sm">
      <Modal.Content>
        <Modal.Header title={t(`${i18nRoot}.title`)} />
        <Modal.Body>
          <Typography variant="body-md">
            {t(`${i18nRoot}.description`)}
          </Typography>
        </Modal.Body>
        <Modal.Footer
          secondaryAction={{
            label: t(`${i18nRoot}.cancel`),
            onClick: () => onOpenChange(false),
          }}
          primaryAction={{
            label: t(`${i18nRoot}.leave`),
            variant: "destructive",
            onClick: handleConfirm,
          }}
        />
      </Modal.Content>
    </Modal.Root>
  );
};
